import {getUserInfoApi} from "@/api/login";

export default {
    namespaced: true,
    state: {
        //用户信息要存储到localStorage本地存储，因为vuex刷新会丢数据
        userInfo: JSON.parse(localStorage.getItem("edb-userInfo")) || {
            permissions: {},
            roles: {},
            user: {}
        }
    },
    mutations: {
        changeMenuData(state, userInfo) {
            state.userInfo = userInfo
            localStorage.setItem("edb-userInfo", JSON.stringify(userInfo))
        }
    },
    actions: {
        async asyncChangeUserInfo({commit}, payload) {
            let res = await getUserInfoApi();
            if (!res) return
            commit('changeMenuData', {
                permissions: res.data.permissions,
                roles: res.data.roles,
                user: res.data,
            })
        }
    }
}
